/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './rich-text.scss';
import './modifier/footer.scss';
import './modifier/inner-content.scss';
import './modifier/grid.scss';
import './modifier/size.scss';
import './modifier/color.scss';
import './modifier/align.scss';
import '../../../atoms/heading/css/modifier/type.scss';
import '../../../atoms/heading/css/modifier/color.scss';
import '../../../atoms/link/css/link.scss';
import '../../../atoms/link/css/modifier/underline.scss';
